import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Faqarea from '../MenFaq/Faqarea'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <Header />
            <main>
                <Breadcrumb mainheading={"Faq"} sub={"Home"} title={"Faq"} />
                <Faqarea />
            </main>
            <Footer />

        </>
    )
}

export default Main